import { Toolbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { selectTitleCheckResponse } from '../../../redux-state/selectors';

const DialogHeader = (props) => {
  const titleCheckResponse = useSelector(selectTitleCheckResponse);
  return (
    <div className="dialog-header">
      <Toolbar className="flex w-full justify-between px-16 py-4 sm:px-24">
        <div>
          <div className={props.text}>
            {props.title}
          </div>
          <div className="text-gray-500 text-sm mt-1 break-all">
            {titleCheckResponse["Transaction ID"]}
          </div>
        </div>

        <div>
          <div className='cursor-pointer' onClick={props.onClose}>
            <CloseIcon style={{ fontSize: 34, backgroundColor: "#F2F4F7" }} />
          </div>
        </div>
      </Toolbar>
    </div>
  );
};

export default DialogHeader;
